/**
 * The one status vocabulary the Connected Apps list speaks.
 *
 * Every integration exposes a different shape (QuickBooks has a sync status,
 * Stripe has capability flags, Wisetack has an enrollment state machine),
 * so `integration-status.ts` collapses all of them into these six values and
 * the list renders them identically. That's what keeps eight unrelated apps
 * scanning as one system.
 *
 * Colour is carried almost entirely by a 6px dot — the label itself stays
 * near-neutral. Eight filled pills stacked down a list read as decoration;
 * eight dots read as a column of state.
 */

export type IntegrationHealth =
  | 'connected'
  | 'attention'
  | 'pending'
  | 'disconnected'
  | 'error'
  | 'unavailable';

export const HEALTH_DOT_CLASSES: Record<IntegrationHealth, string> = {
  connected: 'bg-emerald-500',
  attention: 'bg-amber-500',
  pending: 'bg-sky-500',
  error: 'bg-destructive',
  disconnected: 'bg-muted-foreground/40',
  unavailable: 'bg-muted-foreground/40',
};

export const HEALTH_TEXT_CLASSES: Record<IntegrationHealth, string> = {
  connected: 'text-foreground',
  attention: 'text-amber-700 dark:text-amber-400',
  pending: 'text-sky-700 dark:text-sky-400',
  error: 'text-destructive',
  disconnected: 'text-muted-foreground',
  unavailable: 'text-muted-foreground',
};
